import React from "react";
import "../css/featured.css";
import Navbar from "../Navbar";
import ExploreMore from "../ExploreMore";
export const Women1 = () => {
  return (
    <>
      <Navbar />
      <div className="featured-con">
        <div className="layout">
          <h1 className="article-title">
            The Artist Turned HR Leader: Esi Mmirba Wilson's Blueprint for HR
            Excellence
          </h1>
          <div className="article-category">
            Canada's 10 Most Influential Women Leaders to Watch in 2024
          </div>
          <div className="share-container">
            <div className="share-buttons">
              <button className="share-button linkedin">LinkedIn</button>
              <button className="share-button twitter">Twitter</button>
              <button className="share-button facebook">Facebook</button>
            </div>
          </div>
          <div className="article-image-container">
            <img
              src="./images/Geena-Jackson.jpg"
              alt="Professional woman at desk"
              className="article-image"
            />
            <div className="article-image-caption">
              Geena Jackson is the Creator and Executive Producer of Bears’ Lair
              TV and the Founder and President of Sparkly Frog Clan Productions
              Inc.
            </div>
          </div>
          {/* Article Content */}
          <div className="article-content">
            <p>
              Geena also founded Bears’ Lair Dream Camps, inspiring over 1,200
              Indigenous youth across Canada with lessons in entrepreneurship
              and life skills. Geena’s initiatives foster future leaders and
              vibrant Indigenous economies. Her work continues to drive positive
              change, empowering communities and creating opportunities for
              growth and success. I always knew I wanted to be an entrepreneur
              because… when I was 8-years-old, I had a paper route. During my
              door-to-door collections for payment, I developed relationships
              with my customers and started identifying gaps in their additional
              needs, such as their lawns mowed or their groceries picked up. I
              started my own business then! Entrepreneurship is made for me
              because… it provides me the opportunity to grow as a person, value
              what I work for, and make a difference in everything I do. Social
              impact is the purpose of my entrepreneurial journey. The impact I
              hope to make through my work is… to inspire, educate, elevate, and
              celebrate Indigenous entrepreneurship, which is growing nine times
              faster than any other demographic. Not only do I want to raise
              awareness of our talents as Indigenous people, but I also want to
              educate Indigenous youth across Canada about possible
              opportunities. One of the most important lessons I’ve learned on
              my entrepreneurial journey is… to be passionate and love what you
              are doing. Believe in yourself, ask for help when you need it,
              have some balance, and be kind to yourself. My proudest
              accomplishment is… my 2 beautiful boys, Easton and Hudson. The
              biggest risk I took that paid off was… starting a National TV show
              at 52 years old with zero production or TV experience. I had a
              dream to elevate Indigenous entrepreneurship with a show about
              co-opetition, not competition. I wanted Canada to see who we are
              as people, and the differences we are making to make the world a
              better place. My biggest setback has been… consistent cash flow,
              access to funds, and capacity. As entrepreneurs, we wear so many
              hats, and we need to find the right support. I overcame it by…
              being resilient, creating something impactful, and meeting
              incredible people and organizations to support our initiatives.
              The best advice I’ve received as an entrepreneur was… to find
              something that you are passionate about and that you love.
              Secondly, your network is your net worth. Surround yourself with
              people that are smarter, faster and stronger — they are the ones
              that will inspire you. I surprise people when I tell them… I have
              a National TV show, teach kids all over Canada, have a podcast,
              and 4 other businesses. Time is very limited! If I had an extra
              hour in the day, I would use it to… spend time with my family,
              snuggle my children, and tell them a thousand times how much I
              love them. If you googled me, you still wouldn’t know… all the
              exciting initiatives that our team is working on for the future of
              Indigenous entrepreneurship! Stay tuned! The future excites me
              because… this is the time for Indigenous people in Canada to shine
              and collaborate with business leaders, government, industry, and
              each other to make a positive impact. This is our moment to be
              proud, to share our culture, to demonstrate how much we care, how
              deeply we want to preserve our lands and environment, how we
              respect our Elders, and how we are committed to educating and
              empowering our youth to become the leaders of tomorrow. Together,
              we are making the world a better place.
            </p>
          </div>
        </div>
        
      </div>
     <ExploreMore/>
      
    </>
  );
};
